const printTypeLangs = {
  printTypeList: {
    title: "Danh sách kiểu in",
  },
  printTypeDetail: {
    title: "Chi tiết kiểu in: {{name}}",
  },
  printTypeAdd: {
    title: "Thêm kiểu in",
  },
  error: {
    printTypeList: "lấy danh sách kiểu in lỗi",
    printTypeAdd: "Thêm kiểu in bị lỗi",
    printTypeUpdate: "Cập nhật kiểu in lỗi",
    printTypeDelete: "Xoá kiểu in lỗi",
  },
  success: {
    printTypeAdd: "Thêm kiểu in thành công",
    printTypeUpdate: "Cập nhật kiểu in thành công",
    printTypeDelete: "Xoá kiểu in thành công",
  },
};

export default printTypeLangs;
